
import { Vue, Component } from "vue-property-decorator";
import { ObjectDataSource } from "@/data/Object/ObjecDatatSource";
import { ListDataSource } from "@/data/List/ListDataSource";
import { Filter } from "@/cms-services/filter";
import userModule from "@/store/modules/user";
import { required } from "@/cms-services/consts";

@Component
export default class Home extends Vue {
  dataSource: ObjectDataSource = new ObjectDataSource({
    id: +this.$route.params.id,
    config: {},
    className: "question",
  });

  get caption() {
    return this.dataSource.model?.caption;
  }

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
        exact: true,
      },
      {
        text: "Вопросы-ответы",
        to: "/manage/questions/",
        exact: true,
      },
      {
        text: this.dataSource.model?.caption,
        disabled: true,
      },
    ];
  }

  headers: Array<any> = [
    {
      text: "ID",
      value: "id",
      sortable: true,
      width: 100,
    },
    {
      text: "Дата создания",
      value: "createDate",
      sortable: false,
      width: 200,
    },
    {
      text: "Ответ",
      value: "answer",
      sortable: false,
    },

    {
      text: "Статус",
      value: "instanceStateId",
      sortable: false,
    },
  ];

  createItemModel: any = {
    questionId: +this.$route.params.id,
    createUserId: userModule.profile.userId,
    caption: "",
    description: ""
  };

  createItemFields: any = [

    {
      caption: "Автор",
      editor: "auto-complete-select",
      name: "authorId",
      config: {

        className: "Author",
        labelKeyName: "caption",
        valueKeyName: "id",

        getItems: "getItems"
      },
      validations: [required()],
    },
    {
      caption: "Ответ",
      editor: "memo",
      name: "answer",
      config: {


      },
      attrs: {
        type: "text",
        label: "Ответ",
      },
      validations: [required()],
    },
  ];

  actions: any = {
    getItems: () => this.authorDataSource.items,
  };

  authorDataSource: ListDataSource = new ListDataSource({
    className: "author",
    config: {
      pageIndex: 1,
      pageSize: 3000,
    },
  });
  questionAnswerDataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 100,
      filter: JSON.stringify([
        new Filter("questionId", +this.$route.params.id),
      ]),
    },
    className: "questionAnswer",
  });

  loaded: boolean = false;

  async created() {
    await this.authorDataSource.get();
    this.loaded = true;
  }
}
